<template>
  <page-outline :title="listTitle">
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <f7-list class="mb-2">
                    <f7-list-item >
                      <b-row class="d-flex">
                        <div class="mx-3">
                          <b-button class="btn btnFilter"
                            @click="onRefresh()">
                            <i class="fa-light fa-rotate-right"></i>
                          </b-button>
                        </div>
                        <b-button v-if="canAdd" variant="primary" @click="actionAdd" class="mx-2">
                          <span class="d-inline">{{ $t('common.global.add_provider') }}</span>
                        </b-button>
                      </b-row>
                    </f7-list-item>
                    <!-- Sélection des valeurs de Filtre -->
                    <f7-list-item :class="{'filter-item-section':true}">
                      <b-row class="min-w-100">
                        <!-- <b-col class="d-flex flex-row"> -->
                        <!--Filtre provider -->
                        <b-col lg="3" cols="6" class="filter-item mb-3">
                          <span class="filter-item-title">{{ $t('common.global.provider_title') }}</span>
                          <span class="filter-item-content">
                            <input v-model="name" @input="delayApplyFilter"
                              type="text"
                              :class="{'filter-item-input': true, 'filter-item-input-complete': name}">
                            </input>
                          </span>
                        </b-col>
                        <!-- Filtre identifiant -->
                        <b-col lg="3" cols="6" class="filter-item mb-3">
                          <span class="filter-item-title">{{ $t('common.global.bic') }}</span>
                          <span class="filter-item-content">
                            <input v-model="identifier" @input="delayApplyFilter"
                              type="text"
                              :class="{'filter-item-input': true, 'filter-item-input-complete': identifier}">
                            </input>
                          </span>
                        </b-col>
                        <!-- Filtre network -->
                        <b-col lg="3" cols="6" class="filter-item" v-if="hasClearingFilter">
                          <span class="filter-item-title">{{ $t('common.global.clearing') }}</span>
                          <span class="filter-item-content pt-6px">
                            <select ref="selectTypeAction"
                                    @change="delayApplyFilter"
                                    v-model="network"
                                    class="z-2 position-relative cursor fs-14px-important h-100 mw-none">
                              <option value="">{{ $t('common.all') }}</option>
                              <option v-for="(networkValue, index) in listNetworks"
                                      :value="parseInt(index) ? index : ''">
                                {{ networkValue }}
                              </option>
                            </select>
                          <i class="fa-light fa-chevron-down float-right cursor mt--20px-important" ref="select-action-type"></i>
                          </span>
                        </b-col>
                        <!-- Bouton Effacer et Appliquer -->
                        <b-col lg="3" cols="12" class="d-flex flex-row-reverse mt-3">
                          <b-button class="btn" size="sm"
                            @click="applyFilters()">
                            {{ $t('filter.fltr') }}
                          </b-button>
                          <b-button class="btn mr-3" size="sm"
                            @click="emptyFilters"
                            :disabled="!hasInputFilter">
                            {{ $t('filter.clr_fltr_field') }}
                          </b-button>
                        </b-col>
                      </b-row>
                    </f7-list-item>
                  </f7-list>
        <spinner v-if="activateSpinner"></spinner>
        <b-table v-else-if="this.listItems.length > 0" responsive class="table-striped"
          :items="listItems"
          :fields="fields"
          :key="keyTableProvider"
          hover :selectable="listItems.length > 0"
          empty-text="Pas de résultat"
          @row-selected="onRowSelected">
          <template #cell(name)="data">
            <span>{{ data.value }}</span>
          </template>
          <template #cell(identifier)="data">
            <span>{{ data.value }}</span>
          </template>
          <template #cell(network)="data">
            <span>{{ getNetworkValue(data.value) }}</span>
          </template>
          <template #cell(tokenio)="data">
            <span>{{ data.value ? data.value : '-' }}</span>
          </template>
          <template #cell(dateLastUpdate)="data">
            <span>{{ data.value | formatDateTime }}</span>
          </template>
          <!--
          <template #cell(delete)="data">
              <span class="text-center d-inline-block py-3 w-100" @click="actionDelete($event, data.item.idMember)">
              <i class="fa-regular fa-trash"></i>
              </span>
          </template>
          -->
        </b-table>
        <div class="d-flex justify-content-center mt-5" v-else><b>{{ $t('common.no_result')}}</b></div>
        <!--ANCIENNE TABLE DRO 05/07/2023
        <table v-else relative class="table b-table table-hover" :class="listItems.length ? 'b-table-selectable b-table-select-single' : ''">
          <thead role="rowgroup">
              <tr role="row">
              <th role="columnheader" class="text-center table-condensed-ipad">{{$t('common.global.table_title') }}</th>
              <th role="columnheader" v-if="canEdit" class="text-center table-condensed-ipad col-1">{{ $t('rights.edit') }}</th>
              <th role="columnheader" v-if="canDelete" class="text-center table-condensed-ipad col-1">{{ $t('rights.delete') }}</th>
              </tr>
          </thead>
          <tbody role="rowgroup">
              <tr role="row" v-if="activateSpinner">
              <td role="cell" colspan="3" class="text-center py-0">
                  <spinner class=""></spinner>
              </td>
              </tr>
              <tr role="row" v-else-if="listItems.length" v-for="(item, index) in listItems" :key="'item-' + index" @click="actionDetails($event, listItems.id)">
              <td role="cell" class="text-center">{{item.name}}</td>
              <td role="cell" v-if="canEdit"  class="text-center" @click="actionEdit($event, listItems.id)"><i class="fa-regular fa-pencil"></i></td>
              <td role="cell" v-if="canDelete"  class="text-center" @click="actionDelete($event, listItems.id)"><i class="fa-regular fa-trash"></i></td>
              </tr>
              <tr role="row" v-else class="no-hover">
              <td role="cell" colspan="3" class="text-center font-weight-bold">
                  Pas de résultat
              </td>
              </tr>
          </tbody>
        </table>-->
        <b-row v-if="!activateSpinner" class="mt-1">
          <b-col cols="12">
            <cm-pagination :maxResultsByPage="paginationObject.maxResults" :firstIndex="paginationObject.firstIndex" :nbResultsTotal="paginationObject.nbResultsTotal" :refreshEvent="paginationObject.refresh"></cm-pagination>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>
<script>
import moment from 'moment'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import Pagination from "@/components/common/pagination.vue";

export default {
name: 'ProviderList',
components: {
  'cm-pagination': Pagination,
  'form-write-group-label-input':formWriteGroupLabelInput,
  'page-outline': PageOutline,
  'spinner': Spinner
},
props: {
},
computed: {
  canAdd () {
    return this.$engine.rights.rightIs('rtp_member_ajouter', true) && this.$engine.user.getUserNorm() !== '3'
  },
  canEdit () {
    return this.$engine.rights.rightIs('rtp_member_editer', true)
  },
  canDelete () {
    return this.$engine.rights.rightIs('rtp_member_supprimer', true) && this.$engine.user.getUserNorm() !== '3'
  },
  fields () {
    let fieldsList = [
      { key: 'name', label: this.$t('common.global.provider_title'), thClass: 'text-center', tdClass: 'text-center w-50' },
      { key: 'identifier', label: this.$t('common.global.bic'), thClass: 'text-center', tdClass: 'text-center' },
    ]
    if (this.hasClearingFilter) {
      fieldsList.push({ key: 'network', label: this.$t('common.global.clearing'), thClass: 'text-center', tdClass: 'text-center' })
    }
    if (this.$engine.user.getUserNorm() === '3') {
      fieldsList.push({ key: 'tokenio', label: this.$t('common.global.tokenio'), thClass: 'text-center', tdClass: 'text-center' })
    }
    fieldsList.push({ key: 'dateLastUpdate', label: this.$t('common.global.last_update'), thClass: 'text-center', tdClass: 'text-center' })
    return fieldsList
  },
  hasClearingFilter () {
    let currentRights = this.$engine.rights.getAll()
    let rightNormFound = false
    if (this.$engine.rights.rightIs('super_admin', true)) {
      return true
    }
    Object.entries(currentRights).forEach((right) => {
      if ((right[0].includes('_srtp') || right[0].includes('_hrtp') || right[0].includes('_psd2')) && right[1] === true) {
        rightNormFound = true
      }
    })
    return !rightNormFound
  },
  hasInputFilter () {
    if (
      this.name ||
      this.identifier ||
      this.network) {
      return true
    }
    return false
  },
  listTitle () {
    return this.$i18n.t('common.global.title')
  }
},
data: () => {
  return {
    activateSpinner: false,
    elementSearchedProvider: '',
    paginationObject: {},
    identifier: '',
    keyTableProvider: false,
    listItems: [],
    listNetworks: {},
    name: '',
    network: '',
    sortBy: 'name'
  }
},
created () {
  let hasRightSRTP = this.hasRightSRTP()
  let hasRightHRTP = this.hasRightHRTP()
  let hasRightPSD2 = this.hasRightPSD2()
  if (hasRightSRTP){
    this.listNetworks[1] = this.$t('common.norm.srtp')
  }
  if (hasRightHRTP){
  this.listNetworks[2] = this.$t('common.norm.giro')
  }
  if (hasRightPSD2){
  this.listNetworks[3] = this.$t('common.norm.psd2')
  }
  if (!this.$engine.rights.rightIs('super_admin', true)) {
    this.network = this.$engine.user.getUserNorm()
  }
  this.activateSpinner = true
  this.paginationObject['firstIndex'] = 1
  this.paginationObject['maxResults'] = 15
  this.paginationObject['nbResultsTotal'] = 0
  this.paginationObject['refresh'] = 'provider-page'
  this.$bus.$off('provider-page')
  this.$bus.$on('provider-page', index => {
    this.onRefresh(false ,index)
  })
  this.onRefresh()
},
methods: {
  actionAdd () {
    loadPage(this, { url: '/routing/provider/provider_form/add/-1'})
  },
  actionDelete ($e, id) {
    $e.stopPropagation()
    /*let that = this
    this.$f7.modal({
      title: this.$t('common.security.element_deletion_confirm'),
      buttons: [
        {
          text: this.$t('creation_forms.vldt'),
          onClick: function () {
            let params = {
              IdMember: IdMember
            }
            that.$engine.member.delete(params)
            .then(resp => {
              that.$f7.modal({
                title: that.$t('common.security.ca_deleted'),
                buttons: [
                  {
                    text: 'OK',
                    onClick: function () {
                      return
                    }
                  }
                ]
              })
              loadPage(that, {url: '/security/0'})
            })
            .catch(e => {
              errorMessageAlert(e, that, that.$i18n)
              that.okMessageBox(that.$t('common.security.cert_delete_error'))
            })
          }
        },
        {
          text: this.$t('common.cncl'),
          onClick: function () {
            return
          }
        }
      ]
    })*/
  },
  actionDetails (id) {
    loadPage(this, { url: '/routing/provider/provider_form/view/' + id })
  },
  actionEdit ($e, id) {
    $e.stopPropagation()
    loadPage(this, { url: '/routing/provider/provider_form/edit/' + id })
  },
  applyFilters() {
    this.activateSpinner = true
    clearTimeout(this.timer)
    this.pageCounter = 0
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['nbResultsTotal'] = 0
    let networkValue = this.hasClearingFilter ? this.network : this.$engine.user.getUserNorm()
    let filterConditions = {
      name: this.name,
      identifier: this.identifier,
      idNorm: networkValue,
      maxResults: this.paginationObject.maxResults,
      firstIndex: this.paginationObject.firstIndex,
    }
    this.getProviders(filterConditions)
  },
  delayApplyFilter() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.applyFilters()
    }, 1500)
  },
  emptyFilters() {
    this.name = ''
    this.identifier = ''
    this.network = ''
    this.applyFilters()
  },
  getNetworkValue (val) {
    switch (val) {
      case 'SRTP':
        return this.$t('common.norm.srtp')
      case 'HRTP':
        return this.$t('common.norm.giro')
      case 'PSD2':
        return this.$t('common.norm.psd2')
      default:
        return val
    }
  },
  getProviders (filters) {
    this.$engine.routing.member.fetch(filters)
    .then(resp => {
      let that = this
      let providersList = {}
      that.paginationObject.nbResultsTotal = resp.data.nbTotalResults //actionHistory.length
      that.paginationObject.nbResults = resp.data.Members.length
      providersList = resp.data.Members
      that.updateProviders(providersList)
      that.activateSpinner = false
    })
  },
  onRefresh(noAttach = false, index = 1) {
    this.activateSpinner = true
    this.paginationObject['firstIndex'] = index
    let networkValue = this.hasClearingFilter ? this.network : this.$engine.user.getUserNorm()
    let filterConditions = {
      name: this.name,
      identifier: this.identifier,
      idNorm: networkValue,
      maxResults: this.paginationObject.maxResults,
      firstIndex: this.paginationObject.firstIndex,
    }
    this.getProviders(filterConditions)
  },
  onRowSelected(items) {
    this.keyTableProvider = !this.keyTableProvider
    this.actionDetails(items[0].idMember)
  },
  updateProviders(providersList) {
  this.listItems = providersList
  //this.fillNetworksList()
  this.activateSpinner = false
  },
  hasRightHRTP () {
    let currentRights = this.$engine.rights.getAll()
    let rightHRTPFound = false
    Object.entries(currentRights).forEach((right) => {
      if (right[0].includes('_hrtp') && right[1] === true) {
        rightHRTPFound = true
      }
    })
    return rightHRTPFound
  },
  hasRightPSD2 () {
    let currentRights = this.$engine.rights.getAll()
    let rightPSD2Found = false
    Object.entries(currentRights).forEach((right) => {
      if (right[0].includes('_psd2') && right[1] === true) {
        rightPSD2Found = true
      }
    })
    return rightPSD2Found
  },
  hasRightSRTP () {
    let currentRights = this.$engine.rights.getAll()
    let rightSRTPFound = false
    Object.entries(currentRights).forEach((right) => {
      if (right[0].includes('_srtp') && right[1] === true) {
        rightSRTPFound = true
      }
    })
    return rightSRTPFound
  },

}
}
</script>
